// extracted by mini-css-extract-plugin
export default {"AppWrapper":"app-wrapper_AppWrapper__GwaUi"};